import React, { Fragment } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import { useSelector, useDispatch } from "react-redux/es/exports";

function AdvancedSearch({ fieldsToSearch, dataSettings }) {
  const { display } = dataSettings;

  const precisionSearchQueries = useSelector(
    (state) => state.precisionSearchQueries
  );
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch({
      type: "SET_ADVANCED_SEARCH_ON",
      payload: false,
    });
    dispatch({
      type: "UPDATE_FILTERED_DATA",
    });
  };

  return (
    <Stack spacing={1}>
      <Typography variant="h5" gutterBottom component="div">
        Advanced Search
      </Typography>

      <Fragment>
        {fieldsToSearch.map((fieldName, i) => {
          let value = precisionSearchQueries[fieldName];
          if (!value) {
            value = "";
          }
          return (
            <Box
              component="form"
              sx={{
                "& > :not(style)": { m: 1 },
              }}
              noValidate
              autoComplete="off"
              key={i}
            >
              <TextField
                id="outlined-basic"
                label={display[fieldName]}
                variant="outlined"
                onChange={(e) => {
                  const value = e.target.value;
                  dispatch({
                    type: "HANDLE_PRECISION_SEARCH_BOX_CHANGE",
                    payload: {
                      value,
                      fieldName,
                    },
                  });
                  dispatch({
                    type: "UPDATE_FILTERED_IDS_BASED_ON_PRECISION_SEARCH",
                  });
                  dispatch({
                    type: "UPDATE_FILTERED_DATA",
                  });
                  dispatch({
                    type: "SET_PAGE_NUMBER",
                    payload: 1,
                  });
                }}
                value={value}
              />
            </Box>
          );
        })}
      </Fragment>
      <Button variant="text" onClick={handleClick}>
        Overall Search
      </Button>
    </Stack>
  );
}

export default AdvancedSearch;
